import { useMutation } from '@tanstack/react-query';
import { post } from 'app/shared/utils/fetchr';

export type CgdoCacheObjectType =
  | 'entity'
  | 'instrument'
  | 'txn_event'
  | 'action_event';

interface CacheCgdoPayload {
  object_type: CgdoCacheObjectType;
  hashed_id: string;
}

export const useCacheCgdo = () =>
  useMutation({
    mutationFn: (payload: CacheCgdoPayload) =>
      post('/cgdo/request_single_CGDO_to_be_cached', payload),
  });
